import { render, staticRenderFns } from "./Conceptos.vue?vue&type=template&id=f497dc1a&scoped=true&"
import script from "./Conceptos.vue?vue&type=script&lang=js&"
export * from "./Conceptos.vue?vue&type=script&lang=js&"
import style0 from "./Conceptos.vue?vue&type=style&index=0&id=f497dc1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f497dc1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTab,VTabItem,VTabs,VTooltip})
